import { Component } from '@angular/core';
import {
  NavParams,
  ViewController,
  Platform,
  NavController
} from 'ionic-angular';

import { Token } from '../../app/app.models';
import {
  NativePageTransitions,
  NativeTransitionOptions
} from '@ionic-native/native-page-transitions';

declare var window: any;

@Component({
  selector: 'page-tokeninfo',
  templateUrl: 'tokeninfo.html'
})
export class TokeninfoPage {
  public token$: Token;
  date: string;
  desktop: boolean;

  constructor(
    public navParams: NavParams,
    public viewCtrl: ViewController,
    private nativePageTransitions: NativePageTransitions,
    private platform: Platform,
    public navCtrl: NavController
  ) {
    if (this.platform.is('core')) {
      this.desktop = true;
    } else {
      this.desktop = false;
    }

    this.token$ = navParams.data;
    this.date = this.setDate(this.token$.date);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TokeninfoPage');
  }

  dismiss() {
    if (!this.desktop) {
      let options: NativeTransitionOptions = {
        direction: 'left',
        duration: 600
      };
      this.nativePageTransitions.flip(options);
      this.viewCtrl.dismiss();
    }
    if (this.desktop) {
      this.navCtrl.pop();
    }
  }

  setDate(dt: Date) {
    let dd = dt.getDate();
    let mm = dt.getMonth() + 1;
    let yyyy = dt.getFullYear();
    var day = dd.toString();
    var month = mm.toString();
    if (dd < 10) {
      day = '0' + day;
    }
    if (mm < 10) {
      month = '0' + month;
    }
    return day + '-' + month + '-' + yyyy;
  }
}



// WEBPACK FOOTER //
// ./src/pages/tokeninfo/tokeninfo.ts